export class TournamentError extends Error {
    tournamentId;
    round;
    step;
    constructor(tournamentId, round, step, message) {
        super(message);
        this.tournamentId = tournamentId;
        this.round = round;
        this.step = step;
    }
}
